import styles from "./hero-intro-shared.module.scss";
import VisiblyScrollableV2 from "@/app/features/shared/__to_be_integrated/ui/v2/VisiblyScrollable";
import { Stack } from "@mui/material";
import { ReactNode } from "react";
import clsx from "clsx";

export function DefaultHeroIntroContentRootFrame({
    scrollableChildren,
    bottomChildren,
    stackClassName,
    disableScrollable = false,
}: {
    scrollableChildren: ReactNode;
    bottomChildren?: ReactNode;
    stackClassName?: string;
    disableScrollable?: boolean;
}) {
    return (
        <div className={styles.heroContentSection}>
            <VisiblyScrollableV2 className={styles.heroScrollable} scrollDisabled={disableScrollable}>
                <Stack spacing={4} className={clsx(styles.heroContentStack, stackClassName)}>
                    {scrollableChildren}
                </Stack>
            </VisiblyScrollableV2>
            {bottomChildren}
        </div>
    )
}

export function DefaultHeroIntroHeadingFrame({ children }: { children: ReactNode }) {
    return (
        <Stack spacing={2}>
            {children}
        </Stack>
    );
}

export function DefaultHeroIntroDescriptionFrame({ children }: { children: ReactNode }) {
    return (
        <div className={styles.heroDescription}>
            {children}
        </div>
    );
}

export function DefaultHeroIntroLinksFrame({
    children,
    ariaLabel = "Weiterführende Links",
}: {
    children: ReactNode;
    ariaLabel?: string;
}) {
    return (
        <nav className={styles.heroLinks} aria-label={ariaLabel}>
            {children}
        </nav>
    );
}
